import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ContratoEditarComponent } from './contrato-editar.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: ':id', component: ContratoEditarComponent }
    ])],
    exports: [RouterModule]
})
export class ContratoEditarRoutingModule { }
